import { z as t } from "zod";
const o = t.enum(["contain", "cover", "none"]), n = t.enum(["bleed-grid", "fit-grid"]), a = t.enum(["center", "top", "bottom", "left", "right"]);
export {
  o as a,
  n as b,
  a as c
};
